import { Component, OnInit ,ViewChild} from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { EmpresasService } from '../../../services/empresas/empresas.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import {HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import Swal from "sweetalert2";
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';


@Component({
  selector: 'app-list-aval',
  templateUrl: './list-aval.component.html',
  styleUrls: ['./list-aval.component.scss'],
  providers:[MessagesTitles, MessagesStatus]
})
export class ListAvalComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_RefBancarias=environment.LABEL_REF_BANCARIAS;
  Id_Confirming=environment.ID_CONFIRMING;
  Id_Factoring=environment.ID_FACTORING;
  adjuntarPDF : boolean;
  BloqueoMasivo : boolean;
  desbloqueoMasivo : boolean;
  idEmpresaAdj : string;
  id = '';
  user:any;
  filteredProveeedor: Observable<any[]>;
  filteredProveeedor2: Observable<any[]>;
  dataEmpresa : any;
  idEmpresa_Factor : any;
  form: FormGroup;
  proveedoresArr;
  proveedoresArr2;
  ruc = new FormControl();
  Fruc  = new FormControl();
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [10,20,30,50,100,200];
  docNegociables:any = [];
  loading:boolean=false;
  
  readonly ROLE_ADMIN: number = environment.ROLE_ADMIN_ID;
  readonly ROLE_RIESGO: number = environment.ROLE_RIESGO_ID; // Rol Riesgo desde bd SecurityDBDev
  readonly ROLE_AUDIT: number = environment.ROLE_AUDIT_ID; // Rol Riesgo desde bd SecurityDBDev

  displayedColumns: string[] = 
  ['checked','Num_Doc_Identificacion','Razon_Social','Scoring_Puntaje','Condicion','Estado','Canal','Usuario','AltaFecha','Contrato_Marco'];

  dataSource = new MatTableDataSource( this.docNegociables) ;

  constructor( private empresasService:EmpresasService ,
    private msgTitulos : MessagesTitles,
    private msgStatus:MessagesStatus,
     private router :Router,
     private loginService:LoginService,
     private activateRoute :ActivatedRoute
     ) { 
    
    sessionStorage.setItem('lstAvalCbo',this.docNegociables)
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
      this.form = new FormGroup({
        Estado: new FormControl('X', [Validators.required]),
        TipoEmpresa:new FormControl('J', [Validators.required]),
        Usuario:new FormControl(this.user.Usuario, [Validators.required]),
      });
      
     this.userHasValidRole([this.ROLE_AUDIT]);
  }
  userHasValidRole(id_roles: number[]) {
    if(id_roles.includes(this.user.id_roles)){
      this.displayedColumns = 
      ['Num_Doc_Identificacion','Razon_Social','Estado','Contrato_Marco'];
    };
  }
  ngOnInit() {
    this.empresasService.pagareDatos = "";
    this.activateRoute.params.subscribe( params => {
      if(params['id']){
        this.id =params['id'];
        this.filtradoDocNegociables2(this.id); 
      }else{
        this.id='';
        this.cargarListado();
      }
    })
   
  }

  obtenerId(termino :string){
    this.id = termino;
  }

  obtenerRucRazSocial(termino :string = ''){
    
    if (termino != null && termino != ''){
      
      let termino1 = termino.toLowerCase();                   
  
      for( let p of this.proveedoresArr){
  
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1)  >= 0){
            
            this.id = p.Num_Doc_Identificacion;
          }
  
      }

    }

    }
  

  ObtenerProveedoresCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstavlCbo'));
      this.filteredProveeedor = this.ruc.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProv(state) : this.proveedoresArr.slice()
        )
      );
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  ObtenerProveedoresComboRuc() {
    this.proveedoresArr2 = JSON.parse(sessionStorage.getItem('lstavlCbo'));
   
      this.filteredProveeedor2 = this.Fruc.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProvRuc(state) : this.proveedoresArr2.slice()
        )
      );
   

   
  }


  private _filterProvRuc(value: string): any[] {
    const filterValue = value.toString().toLowerCase();

    return this.proveedoresArr2.filter(
      state => state.Num_Doc_Identificacion.toLowerCase().indexOf(filterValue) === 0
    );
  }
  
  

  filtradoDocNegociables(){
    this.loading = true;
    if (this.ruc.value == null && this.Fruc.value == null || this.ruc.value == "" && this.Fruc.value == ""){
      this.id = "";
    }
    this.empresasService.obtenerAvalJuridico()
          .subscribe( resp => { 
            this.docNegociables = resp;
            if(this.id != ""){
              this.docNegociables = this.docNegociables.filter(p => p.Num_Doc_Identificacion == this.id);
            }
            this.dataSource = new MatTableDataSource( this.docNegociables);
            this.dataSource.sort = this.sort;
            this.id=this.docNegociables.id;
            this.dataSource.paginator = this.paginator;
            this.pageSizeOptions = [15,20,30,50,100,200];
            this.loading = false;
          }, (err: HttpErrorResponse)=> {
            this.loading = false;
            if (err.error instanceof ErrorEvent) {
              console.error("Error Event");  
          } else {
              this.msgStatus.getMessage(err.status);            
          }
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "LISTA PROV. NO OBTENIDO. "+this.msgStatus.message,
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
          })

  }
  filtradoDocNegociables2(id:any){
    this.loading = true;
    if (this.ruc.value == null && this.Fruc.value == null || this.ruc.value == "" && this.Fruc.value == ""){
      this.id = "";
    }
    this.empresasService.obtenerAvalJuridico()
          .subscribe( resp => { 
            this.docNegociables = resp; 
            this.ObtenerProveedoresCombo();
            this.ObtenerProveedoresComboRuc();

            this.dataSource = new MatTableDataSource( this.docNegociables);
            this.dataSource.sort = this.sort;
            this.id=this.docNegociables.id;
            this.dataSource.paginator = this.paginator;
            this.pageSizeOptions = [15,20,30,50,100,200];
            this.loading = false;
          }, (err: HttpErrorResponse)=> {
            this.loading = false;
            if (err.error instanceof ErrorEvent) {
              console.error("Error Event");  
          } else {
              this.msgStatus.getMessage(err.status);            
          }
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "LISTA PROV. NO OBTENIDO. "+this.msgStatus.message,
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
          })

  }

  CerrarVentaAdjunto(){
    this.adjuntarPDF = false;
    this.cargarListado();
  }  

  cargarListado(){
    this.loading = true;
    this.empresasService.obtenerAvalJuridico()
    .subscribe(res => {
      this.docNegociables = res; 
      
      this.ObtenerProveedoresCombo();
      this.ObtenerProveedoresComboRuc();
      this.loading = false;
      this.dataSource = new MatTableDataSource( this.docNegociables);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    }, (er: HttpErrorResponse)=> {
      this.loading = false;
      if (er.error instanceof ErrorEvent) {
        console.error("Error Event");
    } else {
        this.msgStatus.getMessage(er.status);            
    }
    Swal.fire({
      title: this.msgTitulos.Error,
      text: "LISTA PROV. NO OBTENIDO. "+this.msgStatus.message,
      type: "error",
      allowOutsideClick: false,
      heightAuto: false
    });
    });
  }

  contactos(id?:string , razSocial? : string, rucEmpresa? : string) {
    this.loginService.clickGuard = true;
    sessionStorage.setItem('razSocial',razSocial);
    sessionStorage.setItem('rucEmpresa',rucEmpresa);
    this.router.navigate(['/empresas/aval/contactos/',id])
  }

  contratos(id?:string , razSocial? : string, rucEmpresa? : string) {
    this.loginService.clickGuard = true;
    this.empresasService.tipoServicio = this.Id_Factoring
    sessionStorage.setItem('razSocial',razSocial);
    sessionStorage.setItem('rucEmpresa',rucEmpresa);
    this.router.navigate(['/empresas/proveedor/contratos/',id])
  }
  
  bloquear(idproveedor?:string,empresa?:string){
    Swal.fire({
      title: '',
      text: '¿Estás seguro de bloquear al '+this.Label_Proveedor.toLowerCase()+' '+empresa+'?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, bloquear '+this.Label_Proveedor.toLowerCase(),
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.form.controls['Estado'].setValue('X');        
        this.empresasService.actualizarEstadoEmpresa(idproveedor,this.form.getRawValue())
        .subscribe(res => { 
          this.loading = false;
          Swal.fire({
            title: '¡'+this.Label_Proveedor+' bloqueado!',
            text: res["message"],
            type: 'success',
            heightAuto: false
          }).then(resp => {
            if (resp.value == true) {
              this.cargarListado();
            }
          });
    
        })
      } else if (
        result.dismiss === Swal.DismissReason.cancel
      ) {
        this.loading = false;
      }
    })
  }
  
  desbloquear(idproveedor?:string,empresa?:string){
    Swal.fire({
      title: '',
      text: '¿Estás seguro de desbloquear al '+this.Label_Proveedor.toLowerCase()+' '+empresa+'?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, desbloquear '+this.Label_Proveedor.toLowerCase(),
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.form.controls['Estado'].setValue('A');
        this.empresasService.actualizarEstadoEmpresa(idproveedor,this.form.getRawValue())
        .subscribe(res => { 
          this.loading = false;
          Swal.fire({
            title: '¡'+this.Label_Proveedor+' desbloqueado!',
            text: res["message"],
            type: 'success',
            heightAuto: false
          }).then(resp1 => {
            if (resp1.value == true) {
              this.cargarListado();
            }
          });
    
        })
      } else if (
        result.dismiss === Swal.DismissReason.cancel
      ) {
        this.loading = false;
      }
    })
  }
  
  darBaja(idproveedor?:string,empresa?:string){
    Swal.fire({
      title: '',
      text: '¿Estás seguro de dar de baja en el sistema al '+this.Label_Proveedor.toLowerCase()+' '+empresa+'?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, dar de baja',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        this.form.controls['Estado'].setValue('B');
        this.empresasService.actualizarEstadoEmpresa(idproveedor,this.form.getRawValue())
        .subscribe(res => { 
          Swal.fire({
            title: '¡'+this.Label_Proveedor+' dado de baja en el sistema!',
            text: res["message"],
            type: 'success',
            heightAuto: false
           }).then(resp2 => {
            if (resp2.value == true) {
              this.cargarListado();
            }
          });
    
        })
      } else if (
        result.dismiss === Swal.DismissReason.cancel
      ) {
        this.loading = false;
      }
    })
  }
  referenciasBancarias(id : string , razSocial? : string , rucEmpresa? : string){
    this.loginService.clickGuard = true;
    sessionStorage.setItem('razSocial',razSocial);
    this.empresasService.tipoServicio = this.Id_Factoring
    sessionStorage.setItem('rucEmpresa',rucEmpresa);
    this.router.navigate(['/empresas/aval/refBancarias/',id])

  }
  Pagare(element, rucEmpresa? : string) {
    this.loginService.clickGuard = true;
    sessionStorage.setItem('rucEmpresa',rucEmpresa);
    this.router.navigate(['/empresas/proveedor/pagare'])
    this.empresasService.pagareContrato = element; 
    this.empresasService.pagareDatos = element;   
    this.empresasService.pagareDatos.Tipo_Servicio = this.Id_Factoring;   
  }

  editar( id : string, rucEmpresa? : string){
    this.loginService.clickGuard = true;
    sessionStorage.setItem('rucEmpresa',rucEmpresa);
    this.router.navigate(['/empresas/aval/editar/',id])
  }
  
  subirAdjuntos(element : string){
    this.dataEmpresa = element;
    this.adjuntarPDF = true;
  }

  AbrirPopupBloqueo(){
    this.BloqueoMasivo = true;
  }
  CerrarPopupBloqueo(){
    this.BloqueoMasivo = false;
    this.cargarListado();
  }

 
  CerrarPopUp(){
    this.adjuntarPDF = false;
  }
}
